import { useEffect } from 'react';

/**
 * Sets the browser tab title to "{title} | Guild Insights".
 * Resets to "Guild Insights" on unmount.
 */
export function useDocumentTitle(title: string) {
  useEffect(() => {
    document.title = title ? `${title} | Guild Insights` : 'Guild Insights';
    return () => {
      document.title = 'Guild Insights';
    };
  }, [title]);
}
